export default __webpack_public_path__ + "static/media/LogoBankiiiz.586f86ed.jpg";